import { Component, Inject, inject, OnInit, Optional, ChangeDetectorRef } from '@angular/core';
import { Observable } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { environment } from '../../../../../environments/environment';
import { Diary } from '../../../../models/diary.model';
import { OpenOnboardingService } from '../../../../services/open-onboarding.service';
import { Document } from '../../../../models/document.model';
import { HttpErrorResponse, HttpEvent, HttpEventType } from '@angular/common/http';
import { DocumentText } from '../../../../models/documentText.model';
import { DocumentUploaded } from '../../../../models/documentUploaded.model';
import { OnboardingPageLandingEvent } from '../../../../models/events/onboardingPageLandingEvent.model';
import { EventsService } from '../../../../services/events.service';
import { ClientConfigService } from '../../../../services/client-config.service';
import { OnboardingPageSubmitButtonClickedEvent } from '../../../../models/events/onboardingPageSubmitButtonClickedEvent.model';
import { Router, ActivatedRoute } from '@angular/router';
import { OnboardingDocumentsService } from '../../../../services/onboarding-documents.service';
import { MatDivider } from '@angular/material/divider';
import { NgClass } from '@angular/common';
import { IbanCaptureComponent } from '../../components/iban-capture/iban-capture.component';
import { GapInCoverCaptureComponent } from '../../components/gap-in-cover-capture/gap-in-cover-capture.component';
import { IrishRegistrationCaptureComponent } from '../../components/irish-registration-capture/irish-registration-capture.component';
import { NcbTransferDeclarationComponent } from '../../components/ncb-transfer-declaration/ncb-transfer-declaration.component';
import { CreditWorthinessCheckCaptureComponent } from '../../components/credit-worthiness-check-capture/credit-worthiness-check-capture.component';
import { TppEjourneyComponent } from '../../components/tpp-ejourney/tpp-ejourney.component';
import { GenericDocumentCaptureComponent } from '../../components/generic-document-capture/generic-document-capture.component';
import { UploadConfirmationComponent } from '../../components/upload-confirmation/upload-confirmation.component';
import { MatProgressBar } from '@angular/material/progress-bar';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { OrderByPipe } from '../../../pipes/orderby.pipe';

@Component({
  selector: 'app-onboarding-page',
  templateUrl: './onboarding-page.component.html',
  styleUrl: './onboarding-page.component.scss',
  imports: [MatDivider, NgClass, IbanCaptureComponent, GapInCoverCaptureComponent, IrishRegistrationCaptureComponent, CreditWorthinessCheckCaptureComponent, TppEjourneyComponent, GenericDocumentCaptureComponent, UploadConfirmationComponent, MatProgressBar, MatProgressSpinner, OrderByPipe, NcbTransferDeclarationComponent]
})
export class OnboardingPageComponent implements OnInit {

  private openOnboardingService = inject(OpenOnboardingService)
  private eventService = inject(EventsService)
  private clientConfigService = inject(ClientConfigService)
  private onboardingDocumentsService = inject(OnboardingDocumentsService)
  private cdr = inject(ChangeDetectorRef)
  router = inject(Router)
  dialog = inject(MatDialog)
  activatedRoute = inject(ActivatedRoute)
  data!: { policyCode: string, utm_campaign: string, utm_source: string, utm_medium: string };

  chillPortalAddress: string = environment.chill.portalAddress;
  collapsed: boolean = false;
  diaries: Diary[] = [];
  documentList: any[] = [];
  progress: number = 0;
  documentsDiary$: Document[] = [];
  loading: boolean = false;

  constructor(
    @Optional()
    @Inject(MAT_DIALOG_DATA)
    public dialogData: { policyCode: string, utm_campaign: string, utm_source: string, utm_medium: string }
  ) { }

  ngOnInit(): void {
    this.documents = this.onboardingDocumentsService.getDocuments();
    console.log("Onboaring Page Loading")
    console.log("######################")

    this.data = this.dialogData || {
      policyCode: this.activatedRoute.snapshot.params['policyCode'] || '',
      utm_campaign: this.activatedRoute.snapshot.queryParams['utm_campaign'] || '',
      utm_source: this.activatedRoute.snapshot.queryParams['utm_source'] || '',
      utm_medium: this.activatedRoute.snapshot.queryParams['utm_medium'] || ''
    };

    if (this.data.policyCode) {
      this.data.policyCode = this.data.policyCode.toUpperCase();
    }

    if (this.data.policyCode?.length != 9 && !environment.showAllDocumentsForStyling) {
      this.router.navigate(["/400"]);
      return;
    }

    this.loading = true;

    if (environment.showAllDocumentsForStyling) {
      this.setupMockDocuments();
      return;
    }

    this.fetchPolicyDiaries();
  }

  private setupMockDocuments(): void {
    this.documentsDiary$ = this.documents.map((d, index) => {
      let newDocument = { ...d, isSubmitted: index === 0 };
      newDocument.diary = {
        id: d.name, // Uses the document name so the 'iban' component expands by default
        diaryTypeId: d.diaryCode,
        policyCode: 'MOCK-123',
        attempt: 1,
        customerDetails: { name: 'Mock User', email: 'mock@chill.ie', phones: [] },
        docDetails: [],
        status: { approved: false, diaryOpen: true, uploaded: false, reviewed: false },
        driver: { name: 'Mock Driver', dateOfBirth: '1990-01-01', relationToProposer: 'Self' }
      } as any;
      return newDocument;
    });
    // this.documentsDiary$ = this.documentsDiary$.filter(doc => doc.name === 'aditionalDriver');
    this.diaries = this.documentsDiary$.map(doc => doc.diary as any);
    console.warn('MOCKED DOCUMENTS GENERATED FOR STYLING:', this.documentsDiary$);
    this.loading = false;
    this.landingPageEvent();
  }

  private fetchPolicyDiaries(): void {
    this.openOnboardingService
      .getDiaryByPolicyCode(this.data.policyCode)
      .subscribe(
        (res) => {
          debugger
          this.diaries = res || [];
          let newDocumentsDiary: Document[] = [];

          this.diaries.forEach((d, i) => {
            var document = this.documents.filter(
              (x) => x.diaryCode?.trim().toUpperCase() === d.diaryTypeId?.trim().toUpperCase()
            );

            if (!document || document.length === 0) {
              console.warn(`Diary type ${d.diaryTypeId} is disabled or not found in configuration.`);
              return; // Skip this diary
            }

            let newDocument = { ...document[0] }; // Copy object without copy the reference
            newDocument.diary = d;

            console.log('=== MATCHED DOCUMENT ===', {
              diaryTypeId: d.diaryTypeId,
              name: newDocument.name,
              title: newDocument.title,
              info: newDocument.info,
              diaryCode: newDocument.diaryCode
            });

            if (!d.status?.approved) {
              if (d.status?.diaryOpen) {
                if (!d.status?.uploaded && !d.status?.approved) {
                  newDocument.isSubmitted = false;
                } else if (d.status?.uploaded && !d.status?.approved) {
                  newDocument.isSubmitted = true;
                }

                if (newDocument.name === 'aditionalDriver') {
                  newDocument.title = (d.driver?.name ?? 'Additional Driver') + ' Licence';
                }
              }

              newDocumentsDiary.push(newDocument);
            }
          });

          this.documentsDiary$ = newDocumentsDiary;

          console.log('ONBOARDING COMPONENTS REQUIRED');
          console.warn(this.documentsDiary$);
          this.loading = false;
          this.cdr.detectChanges();
          this.landingPageEvent();

          if (this.documentsDiary$.length === 0) {
            this.router.navigate(['/400']);
            if (this.dialogData) this.dialog.closeAll();
          }
        },
        (error) => {
          console.error(error);
          this.loading = false;
          this.cdr.detectChanges();
          this.landingPageEvent();

          this.router.navigate(["/400"]);

          if (this.dialogData) this.dialog.closeAll();
        }
      );
  }

  expandedControl = 'iban';
  progressBarColor = '#28b9d6!important';
  documents: Document[] = [];

  expand(doc: any) {
    // doc.expanded = !doc.expanded;

    // this.collapsed = !this.collapsed;
    if (this.expandedControl === doc.diary.id) this.expandedControl = '';
    else this.expandedControl = doc.diary.id;
  }

  closeDialog() {
    if (this.dialogData) {
      this.dialog.closeAll();
    } else {
      this.router.navigate(['/']);
    }
  }

  onFileUploaded(document: Document) {
    // console.log('ONBOARDING PAGE RECEIVING EVENT');
    // console.log(JSON.stringify(document));

    // this.documentList = document.documentUploadedList;
    document.enableSubmitButton = document.files.length > 0;
  }

  onFileCleaned(document: any) {
    document.enableSubmitButton = document.files.length > 0;
  }

  submitDocument(document: Document) {
    document.enableSubmitButton = false;
    document.enableUploadButton = false;
    const formData = new FormData();

    formData.append('id', document.diary?.id ?? '');
    formData.append('diaryCode', document.diaryCode);
    formData.append('policyCode', this.data.policyCode);
    formData.append('documentValue', document.value ? document.value : '');
    formData.append('type', document.type);
    formData.append('name', document.diary?.customerDetails?.name ?? '');
    formData.append('email', document.diary?.customerDetails?.email ?? '');

    for (var i = 0; i < document.files.length; i++) {
      formData.append('files', document.files[i].file);
    }

    this.handleUploadResponse(this.openOnboardingService.uploadDocuments(formData), document);
  }

  submitTextDocument(document: Document) {
    document.enableSubmitButton = false;

    let doc = <DocumentText>{
      id: document?.diary?.id ?? '',
      diaryCode: document?.diaryCode,
      documentValue: document.value ? document.value : '',
      email: document.diary?.customerDetails?.email ?? '',
      name: document.diary?.customerDetails?.name ?? '',
      policyCode: this.data.policyCode,
      type: document.type,
      keyValues: document.keyValues,
    };

    this.handleUploadResponse(this.openOnboardingService.uploadTextFile(doc), document);
  }

  private handleUploadResponse(uploadObs: Observable<HttpEvent<object>>, document: Document) {
    uploadObs.subscribe(
      (event: HttpEvent<object>) => {
        console.log(event);

        if (event.type === HttpEventType.Response) {
          if (event.ok === true) {
            document.isSubmitted = true;
            this.uploadDocumentEvent(document);
            document.files = [];
            this.cdr.detectChanges();
          } else {
            document.uploadProgress = 0;
            document.responseStatusText = event.statusText;
            document.isSubmitted = false;
            this.cdr.detectChanges();
          }
        } else if (event.type === HttpEventType.UploadProgress) {
          const percentDone = Math.round(
            (event.loaded * 100) / (event.total === undefined ? 0 : event.total)
          );
          document.uploadProgress = percentDone;
          this.cdr.detectChanges();
        }
      },
      (error: HttpErrorResponse) => {
        document.responseStatusText = error.error.message;
        document.isSubmitted = false;
        this.uploadDocumentEvent(document);
        document.errorMessage =
          'Oops... Something went wrong, please try again in a few minutes';
        this.cdr.detectChanges();
      }
    );
  }

  errorMessageClosed(document: Document) {
    document.errorMessage = null;
    document.enableSubmitButton = true;
  }

  onTextDocumentChange(document: Document) {
    document.enableSubmitButton = document.value !== '';
  }

  onMultiTextDocumentChange(data: any) {
    data.document.enableSubmitButton = data.isFormValid;
  }

  uploadDocumentEvent(document: Document) {
    let submitDocumentEvent = <OnboardingPageSubmitButtonClickedEvent>{
      //OID: this.authService.getUserDetail()?.idTokenClaims?.oid,

      timestamp: new Date(),
      policyCode: this.data.policyCode,
      //productType: this.data.policy.productType,
      //policyStatus: this.data.policy.myChillStatus,
      title: document.title,
      diaryCode: document.diaryCode,
      id: document.diary?.id,
      type: document.type,
      documentValue: document.value,
      pagesUploaded: this.getTotalPagesUploaded(document),
      isUploaded: document.isSubmitted,
      errorMessage: document.responseStatusText,
    };

    this.eventService.SubmitDocument(submitDocumentEvent);
  }

  getTotalPagesUploaded(document: Document) {
    let documentsUploadedList = <DocumentUploaded[]>[];

    if (document.type === 'text') {
    } else {
      // documentsUploadedList = document.files.filter((x) => {
      //   <DocumentUploadedModel>{
      //     name: x.name,
      //     extension: x.extension,
      //   };
      // });

      documentsUploadedList = document.files.map((x) => {
        return <DocumentUploaded>{
          name: x.name,
          extension: x.name.split('.').pop(),
        };
      });
    }
    return documentsUploadedList;
  }

  landingPageEvent() {
    let diaryListEvent = <OnboardingPageLandingEvent>{
      //OID: this.authService.getUserDetail()?.idTokenClaims?.oid,
      utm_campaign: this.data.utm_campaign,
      utm_source: this.data.utm_source,
      utm_medium: this.data.utm_medium,
      policyCode: this.data.policyCode,
      timestamp: new Date(),
      diaries: this.diaries,
    };

    this.eventService.onboardingLandingPageEvent(diaryListEvent);
  }
}
